import {camelCase, mapKeys} from 'lodash';
import {MapPosition} from 'app/model/mapPosition';

export class Place {
    constructor() {
        this.lat = null;
        this.lng = null;
        this.name = null;
        this.address = null;
        this.city = null;
        this.openingHours = null;
        this.zipCode = null;
        this.paymentMethods = null;
    }

    static create(data) {
        return Object.assign(
            new Place(),
            data,
        );
    }

    static createFromApi(data) {
        return Object.assign(
            new Place(),
            mapKeys(data, (v,k) => camelCase(k)),
            {paymentMethods: data.info},
        )
    }

    toString() {
        return `${this.name}, ${this.address}, ${this.city}`;
    }

    getMapPosition(zoom = 8) {
        return new MapPosition(zoom, {lat: Number(this.lat), lng: Number(this.lng)});
    }

    get paymentMethodsArray() {
        return this.paymentMethods && this.paymentMethods.split(', ');
    }

    get openingHoursArray() {
        return this.openingHours && this.openingHours.split(', ');
    }
}
